import { useQuery } from "react-query";

import { valuationQueryKeys } from "./queryKeys";
import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { IValuation } from "../../models/valuation/Valuation";

export function useValuationsByPerson(agencyId: string, personId: string) {
  const { get } = useApiHelper();

  const valuations = useQuery({
    queryKey: valuationQueryKeys.byPerson(agencyId, personId),
    queryFn: () =>
      get(
        `/valuation/${agencyId}/person/${personId}`
      ) as unknown as IDefaultResponseWithData<IValuation[]>,
    refetchOnWindowFocus: false,
  });

  return {
    valuations,
  };
}
